module.exports = __webpack_public_path__ + "static/media/clock.0b399069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Teams/Listing/img/clock.svg
// module id = 72
// module chunks = 0